import React, { VFC, useEffect, useState } from 'react'
import styles from '../../styles/front/form/Form.module.sass'

type CustomContentLabel = {
  label: string
}

type CustomContents = {
  form_type: string
  title: string
  pretty_validate_type: {[key: string] : boolean}
  labels: CustomContentLabel[]
}

type Props = {
  customContents: CustomContents[],
  formName: string,
  errors: {[key: string]: string}[],
  updateIsValidCustomContents: any,
  inputedForm: any,
  check: number
}

const CustomFormContents: VFC<Props> = (props: Props) => {
  const { customContents, formName, errors, updateIsValidCustomContents, inputedForm } = props

  function setRequiredArray() {
    return customContents.map((customContent, index) => {
      const isRequired = customContent.pretty_validate_type.required;
      const formType = customContent.form_type;

      if (!isRequired) return true;

      const inputForm = inputedForm && inputedForm[index];

      if (typeof inputForm === 'undefined') return false;

      const isTextForm = formType === "form_text" || formType === "form_textarea";
      const hasTextInput = inputForm && inputForm.text && inputForm.text !== "";
      const hasSelectedInput = inputForm && (inputForm.selected_check_labels || inputForm.selected_radio_label);

      if (isTextForm) {
        return hasTextInput;
      } else {
        return hasSelectedInput;
      }
    });
  }

  const [isValidParams, setIsValidParams] = useState(setRequiredArray())

  function checkIsValidCustomContents() {
    const customContents = document.getElementById('customContents')
    if (!customContents) {
      updateIsValidCustomContents(true)
      return
    }

    if(isValidParams.length != 0 && isValidParams.includes(false)){
      updateIsValidCustomContents(false)
      return
    }

    updateIsValidCustomContents(true)
  }

  const validTypeValue = (validateTypes: {[key: string] : boolean}) => {
    const validates = []
    Object.entries(validateTypes).map((validateType) => {
      if (validateType[1]) {
        validates.push(validateType[0])
      }
    })
    return validates.join(' ')
  }

  const [erroeTexts, setErroeTexts] = useState(new Array(customContents.length).fill(""))
  const [isFirstInputs, setIsFirstInputs] = useState(new Array(customContents.length).fill(true))

  function changeText(index, value, isRequired) {
    if(!isRequired) return

    let newErrors = [...erroeTexts]
    let newIsFirstInputs = [...isFirstInputs]
    let newIsValids = [...isValidParams]
    if(value != ""){
      newErrors[index] = ""
      newIsFirstInputs[index] = false
      newIsValids[index] = true
    }else{
      newErrors[index] = "入力してください"
      newIsValids[index] = false
    }
    setErroeTexts(newErrors)
    setIsFirstInputs(newIsFirstInputs)
    setIsValidParams(newIsValids)
  }

  function changeTextArea(index, value, isRequired) {
    if(!isRequired) return

    let newErrors = [...erroeTexts]
    let newIsFirstInputs = [...isFirstInputs]
    let newIsValids = [...isValidParams]
    if(value != ""){
      newErrors[index] = ""
      newIsFirstInputs[index] = false
      newIsValids[index] = true
    }else{
      newErrors[index] = "入力してください"
      newIsValids[index] = false
    }
    setErroeTexts(newErrors)
    setIsFirstInputs(newIsFirstInputs)
    setIsValidParams(newIsValids)
  }

  function changeCheck(index) {
    let newErrors = [...erroeTexts]
    let newIsFirstInputs = [...isFirstInputs]
    let newIsValids = [...isValidParams]
    const checkBoxForm = document.getElementById('required_form_' + index)
    if (checkBoxForm) {
      const checkboxList = checkBoxForm.querySelectorAll("input[type='checkbox']")
      if(checkboxList.length != 0){
        if (Array.prototype.slice.call(checkboxList).find((checkboxInput) => checkboxInput.checked === true)) {
          newErrors[index] = ""
          newIsFirstInputs[index] = false
          newIsValids[index] = true
        }else{
          newErrors[index] = "回答してください"
          newIsValids[index] = false
        }
      }
      setErroeTexts(newErrors)
      setIsFirstInputs(newIsFirstInputs)
      setIsValidParams(newIsValids)
    }
  }

  function changeRadio(index) {
    let newErrors = [...erroeTexts]
    let newIsFirstInputs = [...isFirstInputs]
    let newIsValids = [...isValidParams]
    const checkBoxForm = document.getElementById('required_form_' + index)
    if (checkBoxForm) {
      const radioButtonlist = checkBoxForm.querySelectorAll("input[type='radio']")
      if(radioButtonlist.length != 0){
        if (Array.prototype.slice.call(radioButtonlist).find((checkboxInput) => checkboxInput.checked === true)) {
          newErrors[index] = ""
          newIsFirstInputs[index] = false
          newIsValids[index] = true
        }else{
          newErrors[index] = "回答してください"
          newIsValids[index] = false
        }
      }
    }
      setErroeTexts(newErrors)
      setIsFirstInputs(newIsFirstInputs)
      setIsValidParams(newIsValids)
  }

  function checkBlank() {
    const customContents = document.getElementById('customContents')
    if (customContents) {
      let errors = [...erroeTexts]
      let firstInputs = [...isFirstInputs]
      let isValids = [...isValidParams]

      const textForms = customContents.querySelectorAll("input[type='text']:required")
      if (textForms) {
        Array.from(textForms).forEach((text) => {
          if(text.value === ''){
            let componentNumber = text.name.replace(/\D*/g, '')
            errors[Number(componentNumber)] = "入力してください"
            firstInputs[Number(componentNumber)] = false
            isValids[Number(componentNumber)] = false
            updateIsValidCustomContents(false)
          }
        })
      }

      const textAreaForm = customContents.querySelectorAll("textarea:required")
      if (textAreaForm) {
        Array.from(textAreaForm).forEach((text) => {
          if(text.value === ''){
            let componentNumber = text.name.replace(/\D*/g, '')
            errors[Number(componentNumber)] = "入力してください"
            firstInputs[Number(componentNumber)] = false
            isValids[Number(componentNumber)] = false
            updateIsValidCustomContents(false)
          }
        })
      }

      const radioButtonForm = document.getElementsByName('requiredRadioForm')
      if (radioButtonForm) {
        radioButtonForm.forEach((radioForm) => {
          const radioButtonlist = radioForm.querySelectorAll("input[type='radio']")
          if (!Array.prototype.slice.call(radioButtonlist).find((checkboxInput) => checkboxInput.checked === true)) {
            let componentNumber = radioButtonlist[0].name.replace(/\D*/g, '')
            errors[Number(componentNumber)] = "回答してください"
            firstInputs[Number(componentNumber)] = false
            isValids[Number(componentNumber)] = false
            updateIsValidCustomContents(false)
          }
        })
      }

      const checkBoxForm = document.getElementsByName('requiredCheckBoxForm')
      if (checkBoxForm) {
        checkBoxForm.forEach((radioForm) => {
          const checkboxList = radioForm.querySelectorAll("input[type='checkbox']")
          if (!Array.prototype.slice.call(checkboxList).find((checkboxInput) => checkboxInput.checked === true)) {
            let componentNumber = checkboxList[0].name.replace(/\D*/g, '')
            errors[Number(componentNumber)] = "回答してください"
            firstInputs[Number(componentNumber)] = false
            isValids[Number(componentNumber)] = false
            updateIsValidCustomContents(false)
          }
        })
      }
      setErroeTexts(errors)
      setIsFirstInputs(firstInputs)
      setIsValidParams(isValids)
    }
  }

  useEffect(() => {
    checkIsValidCustomContents()
  }, [isValidParams])

  useEffect(() => {
    if (props.check != 0) {
      checkBlank()
    }
  }, [props.check]);

  return (
    <div id={"customContents"}>
      {customContents.map((content, index) => (
        <div className={content.form_type !== 'form_text' ? styles.customInputContainer : styles.inputContainer} key={index}>
          <div>
            <label  className={styles.label + " " + styles.customContentLabel}>
              <div className={styles.labelTitle}>{content.title}</div>
              {content.form_type === 'form_checkbox' && (
                <div className={styles.note + " " + styles.multipleAnswerTextSp}>(複数回答)</div>
              )}
              <div className={styles.labelTag + " " + (content.pretty_validate_type.required ? styles.required : styles.optional)}>
                {content.pretty_validate_type.required ? '必須' : '任意'}
              </div>
            </label>
            {content.form_type === 'form_checkbox' && (
              <div className={styles.note + " " + styles.multipleAnswerTextPc}>(複数回答)</div>
            )}
          </div>
          {content.form_type === 'form_text' && (
            <div className={styles.inputArea}>
              <input
                onChange={(e) => changeText(index, e.target.value, content.pretty_validate_type.required)}
                type="text"
                name={`${formName}[${index}][text]`}
                maxLength={content.pretty_validate_type.character_limit ? '300' : null}
                required={content.pretty_validate_type.required}
                className={`${styles.formInput} ${content.pretty_validate_type.required && !isFirstInputs[index] && erroeTexts && !erroeTexts[index] ? styles.inputColor : ''} ${(errors && errors[index] || erroeTexts && erroeTexts[index]) && styles.errorInput + " error"}`}
                defaultValue={inputedForm ? inputedForm[index]["text"] : ''}
              />
              <div className={styles.note + " " + styles.notice}>{content.pretty_validate_type.character_limit ? '※300文字まで入力できます' : ''}</div>
              <div>
                {(errors && errors[index]) &&  (
                  <div className={styles.errorText}>{errors[index]}</div>
                )}
              </div>
              <div>
                {(erroeTexts && erroeTexts[index]) &&  (
                  <div className={styles.errorText}>{erroeTexts[index]}</div>
                )}
              </div>
            </div>
          )}

          {content.form_type === 'form_textarea' && (
            <div className={styles.inputArea}>
              <textarea
                onChange={(e) => changeTextArea(index, e.target.value, content.pretty_validate_type.required)}
                name={`${formName}[${index}][text]`}
                maxLength={content.pretty_validate_type.character_limit ? '300' : null}
                required={content.pretty_validate_type.required}
                defaultValue={inputedForm ? inputedForm[index]["text"] : ''}
                className={`${content.pretty_validate_type.required && !isFirstInputs[index] && erroeTexts && !erroeTexts[index] ? styles.inputColor : ''} ${(errors && errors[index] || erroeTexts && erroeTexts[index]) ? styles.errorInput + " error" : ''}`}
              />
              <div className={styles.note + " " + styles.notice}>{content.pretty_validate_type.character_limit ? '※300文字まで入力できます' : ''}</div>
              {(errors && errors[index]) &&  (
                <div className={styles.errorText}>{errors[index]}</div>
              )}
              {(erroeTexts && erroeTexts[index]) &&  (
                <div className={styles.errorText}>{erroeTexts[index]}</div>
              )}
            </div>
          )}

          {content.form_type === 'form_checkbox' && (
            <div>
              <div className={`${styles.checkboxRadioContainer} ${!isFirstInputs[index] && erroeTexts && !erroeTexts[index] ? styles.inputColor : ''}  ${(errors && errors[index] || erroeTexts && erroeTexts[index]) && styles.errorInput + " error"}`} name={content.pretty_validate_type.required ? 'requiredCheckBoxForm' : ''}  id={content.pretty_validate_type.required ? "required_form_" + index : ""}>
                {content.labels && (
                  <>
                    {content.labels.map((label, i) => (
                      <div key={i} className={styles.checkList}>
                        <input
                          onChange={() => changeCheck(index)}
                          id={`checkbox_label_${index}_${i}`}
                          name={`${formName}[${index}][selected_check_labels][]`}
                          type="checkbox"
                          value={label.label}
                          className={styles.formCheckbox}
                          defaultChecked={inputedForm ? inputedForm[index]["selected_check_labels"]?.includes(label.label) : null}
                        />
                        <label htmlFor={`checkbox_label_${index}_${i}`} className={styles.formCheckboxLabel}>{label.label}</label>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div>
                {(errors && errors[index]) &&  (
                  <div className={styles.errorText}>{errors[index]}</div>
                )}
              </div>
              <div>
                {(erroeTexts && erroeTexts[index]) &&  (
                  <div className={styles.errorText}>{erroeTexts[index]}</div>
                )}
              </div>
            </div>
          )}

          {content.form_type === 'form_radio' && (
            <div>
              <div className={`${styles.checkboxRadioContainer} ${!isFirstInputs[index] && erroeTexts && !erroeTexts[index] ? styles.inputColor : ''}  ${(errors && errors[index] || erroeTexts && erroeTexts[index]) && styles.errorInput + " error"}`} name={content.pretty_validate_type.required ? 'requiredRadioForm' : ''} id={content.pretty_validate_type.required ? "required_form_" + index : ""}>
                {content.labels && (
                  <>
                    {content.labels.map((label, k) => (
                      <div key={k} className={styles.checkList}>
                        <input
                          onChange={() => changeRadio(index)}
                          id={`radio_label_${index}_${k}`}
                          type="radio"
                          name={`${formName}[${index}][selected_radio_label]`}
                          value={label.label}
                          className={styles.formRadio}
                          defaultChecked={inputedForm ? inputedForm[index]["selected_radio_label"]?.includes(label.label) : null}
                        />
                        <label htmlFor={`radio_label_${index}_${k}`} className={styles.formRadioLabel}>{label.label}</label>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div>
                {(errors && errors[index]) &&  (
                  <div className={styles.errorText}>{errors[index]}</div>
                )}
              </div>
              <div>
                {(erroeTexts && erroeTexts[index]) &&  (
                  <div className={styles.errorText}>{erroeTexts[index]}</div>
                )}
              </div>
            </div>
          )}

          <input type="hidden" name={`${formName}[${index}][title]`} value={content.title}/>
          <input type="hidden" name={`${formName}[${index}][form_type]`} value={content.form_type}/>
          <input type="hidden" name={`${formName}[${index}][validate_type]`} value={validTypeValue(content.pretty_validate_type)}/>
        </div>
      ))}
    </div>
  )
}

export default CustomFormContents
